
import { Component } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import DynamicRouter from '../components/dynamicRouter';
import { getRouteName } from './index';

const WHITE_LIST = ['/login', '/404', '/*'];

const withLocation = (WrappedComponent) => (props) => {
    const location = useLocation();
    return <WrappedComponent {...props} location={location} />;
};

class RouterAuth extends Component {
    // 👇 新增：组件挂载时设置标题
    componentDidMount() {
        this.updateDocumentTitle();
    }

    // 👇 新增：路由变化时更新标题
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.updateDocumentTitle();
        }
    }

    // 👇 新增：获取用户信息
    getUserInfo() {
        try {
            const userStr = localStorage.getItem('userInfo');
            return userStr ? JSON.parse(userStr) : null;
        } catch {
            return null;
        }
    }

    // 👇 新增：更新文档标题的核心方法
    updateDocumentTitle() {
        const { location } = this.props;
        const pathname = location.pathname;

        // 从路由配置读取 name 字段
        const pageName = getRouteName(pathname);

        // 获取用户信息
        const userInfo = this.getUserInfo();

        // 基础标题（环境变量或默认值）
        const baseTitle = process.env.REACT_APP_TITLE || 'DataViz Pro';

        // 拼接标题
        if (userInfo?.username) {
            // 登录状态：用户名 - 页面名 - 平台名
            document.title = `${userInfo.username} - ${pageName} - ${baseTitle}`;
        } else {
            // 未登录状态：页面名 - 平台名
            document.title = `${pageName} - ${baseTitle}`;
        }
    }

    render() {
        const { location, children } = this.props;
        const token = localStorage.getItem('token');
        const isWhiteListed = WHITE_LIST.includes(location.pathname);

        // 白名单路径直接放行
        if (isWhiteListed) {
            return children;
        }

        // 有token的用户可以访问所有路由
        if (token) {
            return children;
        }

        // 未登录且不是白名单路径，重定向到登录页
        return <Navigate to='/login' />;
    }
}

const RouterAuthWithLocation = withLocation(RouterAuth);

const AuthRoutesRenderer = () => (
    <RouterAuthWithLocation>
        <DynamicRouter />
    </RouterAuthWithLocation>
);

export default AuthRoutesRenderer;